import { useEffect } from 'react';

export default function OAuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const provider = state ? state.split(':')[0] : null;

    if (window.opener) {
      window.opener.postMessage(
        { type: 'oauth_callback', code, provider },
        window.location.origin
      );
      window.close();
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-[var(--bg)]">
      <p className="text-[var(--muted)]">Autenticando...</p>
    </div>
  );
}
